import axios from "axios";
// import envInstants from "../../libs/configs/env";

const apiExcept = "auth/login";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
});
export default instance;

export function setDefaultURL(url) {

  instance.defaults.baseURL = url;

}
